import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension, type CustomFieldValidator } from '@backstage/plugin-scaffolder-react';
import { RepositoryNamePreview } from './RepositoryNamePreview';

const DEFAULT_MAX_LENGTH = 64;

const repositoryNameValidation: CustomFieldValidator<string, { maxLength?: number }> = (value, validation, context) => {
  const maxLength = context.uiSchema?.['ui:options']?.maxLength ?? DEFAULT_MAX_LENGTH;
  if (value && value.length > maxLength) {
    validation.addError(`The name must not exceed ${maxLength} characters. Current length: ${value.length}.`);
  }
};

/**
 * Scaffolder field extension that displays a computed repository name
 * based on systemName, componentName, and suffixName fields.
 *
 * Usage in a template YAML:
 * ```yaml
 * repositoryName:
 *   title: Repository Name
 *   type: string
 *   ui:field: RepositoryNamePreview
 *   ui:options:
 *     maxLength: 64
 * ```
 */
export const RepositoryNamePreviewExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'RepositoryNamePreview',
    component: RepositoryNamePreview,
    validation: repositoryNameValidation,
    schema: {
      returnValue: { type: 'string' },
    },
  }),
);
